export default __webpack_public_path__ + "static/media/engagement5.bc687fed.png";